import { Award } from 'lucide-react'
import { HTMLProps } from 'react'
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar'
import { Colour_fromString } from 'utils/colour'
import { cn } from 'app/lib/utils'

type Size = {
    width: number
    height: number
}

type SizeVaraitns = {
    small: Size
    small2: Size
    medium: Size
    large: Size
}

const avatarSizeList: SizeVaraitns = {
    small: { width: 48, height: 48 },
    small2: { width: 90, height: 90 },
    medium: { width: 124, height: 124 },
    large: { width: 192, height: 192 }
}
const CustomAvatar = ({
    size,
    avatarURL,
    children,
    premium,
    className
}: {
    size?: keyof SizeVaraitns | null
    userId?: string
    avatarURL?: string | null
    children?: string
    premium?: boolean
    className?: HTMLProps<HTMLElement>['className']
}) => {
    const dimensions = size != null ? avatarSizeList[size] : undefined

    return (
        <div className='relative' style={dimensions ? { width: dimensions.width, height: dimensions.height } : undefined}>
            <Avatar className={cn(`border-2 text-foreground w-full h-full`, className)}>
                <AvatarImage
                    className='object-cover'
                    src={typeof avatarURL === 'string' && avatarURL ? avatarURL : ''}
                    alt={undefined}
                />
                <AvatarFallback> {children ? children[0] : undefined}</AvatarFallback>
            </Avatar>
            {premium && (
                <Award
                    className='premium-icon'
                    style={{ position: 'absolute', color: 'goldenrod', top: '30px', left: '37px' }}
                />
            )}
        </div>
    )
}

export const StringAvatar = (name: string) => {
    return {
        sx: {
            bgcolor: Colour_fromString(name)
        },
        children: `${name.split(' ')[0][0]}`
    }
}

export default CustomAvatar
